import styled from "@emotion/styled";
import { MAX_DESKTOP_GRID_WIDTH, MOBILE_QUERY_MAX_WIDTH, MOBILE_QUERY_MAX_WIDTH_M, SM } from "constants/vp-sizes";
import { MOBILE_GRID_IMAGE_SIZE } from "segments/desktop/grid/grid-service";
import { getComponentShadow } from "segments/desktop/constants";
const MOBILE_GRID_IMAGE_SIZE_PX = `${MOBILE_GRID_IMAGE_SIZE}px`;
const SM_PX = `${SM}px`;
const MAX_DESKTOP_GRID_WIDTH_PX = `${MAX_DESKTOP_GRID_WIDTH}px`;
const ITEMS_MARGIN = 16;
const ITEMS_MARGIN_PX = `${ITEMS_MARGIN}px`;
export const StyledImagesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  &.no-wrap {
    flex-wrap: nowrap;

    @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
      flex-wrap: wrap;
    }
  }

  .grid-image-container {
    display: flex;
    flex-direction: column;
    margin: ${ITEMS_MARGIN_PX};
    padding: 16px 0;
    width: var(--grid-width);

    &.dynamic-width {
      width: unset;
      flex: 1 1 0;

      @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
        width: var(--grid-width);
        flex: unset;
      }
    }

    .full-paragraph-wrapper {
      flex: 1;
      margin-top: 16px;

      &.buttons-alignment {
        .button-wrapper {
          min-height: 56px;
          align-items: end;
          margin-top: auto;
        }
      }

      .full-paragraph {
        height: 100%;
      }
    }

    .grid-image-wrapper {
      &.with-shadow {
        ${getComponentShadow()}
      }
    }
  }

  @media (min-width: ${SM_PX}) and (max-width: ${MAX_DESKTOP_GRID_WIDTH_PX}) {
    .grid-image-container {
      width: calc(33vw - ${ITEMS_MARGIN * 2}px) !important;

      .grid-image {
        width: 100% !important;

        .image {
          width: 100% !important;
        }
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    .grid-image-container {
      .grid-image-wrapper {
        .grid-image {
          .image {
            width: ${MOBILE_GRID_IMAGE_SIZE_PX};
            height: auto;
          }
        }
      }
    }
  }
`;
